<script setup>
const route = useRoute()
const mapName = route.params.pref
const isMapView = () => {
  if (mapName === 'tokyo' || mapName === 'aichi' || mapName === 'osaka') {
    return true
  }
  return false
}
if (!isValidAreaAndPref(route.params.area, mapName)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('pref', getFullPrefectureName(mapName))
const breadCrumbList = getBreadCrumb(route.params.area, mapName)
const [pickupLivecamList, pointLivecamList] = await Promise.all([
  useFetch('/api/livecam/pickuplist', { query: { target: mapName } }),
  useFetch('/api/livecam/pointlist', { query: { target: mapName } })
]).then((responses) => responses.map((res) => res.data))
const { sortPickupLivecamList, sortRemainingPreflist } = sortPrefLivecamData(pickupLivecamList.value, pointLivecamList.value)
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <template v-if="isMapView()">
        <div class="frame">
          <LivecamPrefMap :pref="mapName" />
          <LivecamList
            :list="sortPickupLivecamList"
          />
          <LivecamPointList
            v-if="sortRemainingPreflist.length!==0"
            :list="sortRemainingPreflist"
          />
        </div>
      </template>
      <template v-if="!isMapView()">
        <div class="frame">
          <CommonPageTitle
            :title="`${getPrefectureName(mapName)}のライブカメラ`"
          />
          <LivecamList
            :list="sortPickupLivecamList"
          />
          <LivecamPointList
            v-if="sortRemainingPreflist.length!==0"
            :list="sortRemainingPreflist"
          />
        </div>
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
